import React, { useCallback, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ShowMore from '@Components/Results/utils/ShowMore';
import InnerHTML from '@Components/InnerHTML';

const DEFAULT_CHEMICAL_NAMES_COUNT = 7;
const IDENTIFICATION_DATA_CLASS = 'rx-substance-identification';
const IDENTIFICATION_DATA_CONTAINER = '#rx-substance-identification';
const sliceChemicalNamesList = (chemicalNamesList) => chemicalNamesList.slice(0, DEFAULT_CHEMICAL_NAMES_COUNT);
const areChemicalNamesListsEqual = (chemicalNamesList = [], nextChemicalNames = []) =>
  chemicalNamesList.length === nextChemicalNames.length && nextChemicalNames.every((name) => chemicalNamesList.includes(name));

function SubstanceIdentificationChemicalNamesList({ chemicalNames = [] }) {
  const [fullChemicalNamesList, setFullChemicalNamesList] = useState(chemicalNames);
  const [chemicalNamesList, setChemicalNamesList] = useState(() => sliceChemicalNamesList(chemicalNames));

  useLayoutEffect(() => {
    if (areChemicalNamesListsEqual(fullChemicalNamesList, chemicalNames)) {
      return;
    }

    setFullChemicalNamesList(chemicalNames);
    setChemicalNamesList(sliceChemicalNamesList(chemicalNames));
  }, [chemicalNames, fullChemicalNamesList]);

  const showLessChemicalNames = useCallback(() => {
    setChemicalNamesList(sliceChemicalNamesList(fullChemicalNamesList));
  }, [fullChemicalNamesList]);

  const showMoreChemicalNames = useCallback(
    () =>
      new Promise((resolve) => {
        setChemicalNamesList(fullChemicalNamesList);
        resolve();
      }),
    [fullChemicalNamesList]
  );

  const fullChemicalNamesListLength = fullChemicalNamesList.length;

  if (!fullChemicalNamesListLength) {
    return null;
  }

  const chemicalNamesListLength = chemicalNamesList.length;

  return (
    <div className={`${IDENTIFICATION_DATA_CLASS}__row ${IDENTIFICATION_DATA_CLASS}__row--chemical-names chemical-names-substance-row`}>
      <dt className={`${IDENTIFICATION_DATA_CLASS}__term`}>Chemical Names:</dt>
      <dd className={`${IDENTIFICATION_DATA_CLASS}__description chemical-names-substance-row__content`}>
        <div className="chemical-names-substance-row__list">
          {chemicalNamesList.map((name, index) => (
            <React.Fragment key={name}>
              <InnerHTML mode="escapeCustom" tag="span" className="dangerously-set-td chemical-names-substance-td" html={name} />
              {index !== chemicalNamesListLength - 1 && <span className="separator" />}
            </React.Fragment>
          ))}
        </div>

        {fullChemicalNamesListLength > DEFAULT_CHEMICAL_NAMES_COUNT && (
          <div className="chemical-names-substance-row__actions">
            <ShowMore
              labelAll="Show all chemical names"
              initial={DEFAULT_CHEMICAL_NAMES_COUNT}
              current={chemicalNamesListLength}
              total={fullChemicalNamesListLength}
              container={IDENTIFICATION_DATA_CONTAINER}
              moreHandler={showMoreChemicalNames}
              lessHandler={showLessChemicalNames}
            />
          </div>
        )}
      </dd>
    </div>
  );
}

export default SubstanceIdentificationChemicalNamesList;

SubstanceIdentificationChemicalNamesList.propTypes = {
  chemicalNames: PropTypes.array,
};
